<template>
  <div class="dagschema" @click="toonDialoog">
      <v-toolbar-title class="deep-purple lighten-2 white--text body-2 c"  >{{dag}}</v-toolbar-title>

<v-card>
  <h5><v-icon>assignment</v-icon>{{huidigAgendaPunt.taak}}</h5>
  <h5><v-icon>feedback</v-icon>{{huidigAgendaPunt.les}}</h5>
  <h5><v-icon>date_range</v-icon>{{huidigAgendaPunt.planning}}</h5>
</v-card>

  </div>
</template>
<script>
  import moment from 'moment'
  export default{
    data(){
      return{
        taak:"",
        les:"",
        planning:"",
        dagString:"",
        datumBestaat:false,
        dagObject:{}


      }
    },
    computed:{
      dag(){
        moment.locale("nl")
        var startdag= moment().day(1)
        startdag.add(this.week,"week")
        var huidigeDag = startdag.add((this.extradagen),"days")
        this.dagString = huidigeDag.format("YYYYMMDD")
        return huidigeDag.format("dddd D MMMM YYYY")
      },
      agendaPunten(){
        return this.$store.getters.agendaPunten
      },
      huidigAgendaPunt(){
        this.dagObject.taak = ""
        this.dagObject.les = ""
        this.dagObject.planning = ""
        this.dagObject.datum = this.dagString
        this.datumBestaat = false
        this.actieveKey = null
        for(var i=0; i<this.agendaPunten.length;i++){
          console.log(this.dagString +"===?" +this.agendaPunten[i].datum)
          if(this.dagString == this.agendaPunten[i].datum){
            console.log("er is een match!")
            this.dagObject.taak = this.agendaPunten[i].taak
            this.dagObject.les= this.agendaPunten[i].les
            this.dagObject.planning= this.agendaPunten[i].planning
            this.datumBestaat = true

            this.actieveKey = this.agendaPunten[i].id
          }


        }
        return this.dagObject
      }

    },
    methods:{
      toonDialoog(){
        console.log( "de key is "+this.actieveKey)
        this.$store.state.actieveLes = this.dagObject.les
        this.$store.state.actievePlanning= this.dagObject.planning
        this.$store.state.actieveTaak = this.dagObject.taak
        this.$store.state.actieveDag = this.dagString
        this.$store.state.actieveDagZin = this.dag
        this.$store.commit("setActieveDatumBestaat",this.datumBestaat)
        this.$store.state.actieveKey = this.actieveKey
        this.$store.state.vulAan = true
      }
    },
    props:["week","extradagen"]
  }

</script>
<style>
.dagschema{
  width:100%;
}
 .c{
   text-align: center;
 }
</style>



// WEBPACK FOOTER //
// src/components/dagschema.vue